import { render, staticRenderFns } from "./p23.vue?vue&type=template&id=614a79f0&scoped=true&"
import script from "./p23.vue?vue&type=script&lang=js&"
export * from "./p23.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614a79f0",
  null
  
)

export default component.exports